<template>
  <div class="u-wrap">
    <div>
    <!-- <u-subsection :list="list" :current="current" @change="change"></u-subsection> -->
    <div class="u-search">
      <input placeholder="请输入要搜索的内容" v-model="keyword" class="input" />
      <div class="u-btn" @click="clickSearch1">搜索</div>
    </div>
   </div>
    <div class="u-menu-wrap" >
        <van-empty v-if="dataList.length == 0" description="暂无数据" />
       <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading"  offset="20" :finished="finished" finished-text="" @load="onLoad">
            <div style="width:100vw;">
             <hybCard :list="dataList"></hybCard>
          </div> 
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getAction, postAction ,postParam } from '@/api/manage'
import uSubsection from '@/components/page/u-subsection.vue'
import hybCard from '@/views/common/hyb-card.vue'
export default {
  components: {
    uSubsection,
    hybCard,
  },
  data() {
    return {
      current: 0, // 预设当前项的值
      list: [],
      keyword: '',
      dataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      typeArr:['0','01','02','03'],//01,02,03
      type:'01',
      pageNo:0,
    }
  },
  created(){
  
   this.type =  this.$route.query.code;
   let title =  this.$route.query.title;
  //  document.title = title;
  //  this.onRefresh();
  },
  mounted(){
    this.onRefresh();
  },
  computed: {},
  methods: {
    change(index) {
   
       this.current = index;
       let i = Number(index);
       this.type = this.typeArr[i];
       this.onRefresh();
       
    },
    clickSearch1() {
      this.refreshing = true;
      this.onRefresh();
    },
    getData() {
      let openId = this.$store.getters.openId;
      let params = {pageNo:this.pageNo,informantName:this.keyword,openId:openId};
      // getAction('/zhshj/csqxxglxxgk/query/list/by/orgCode',params)
      getAction("/zhshj/djylwtq/pageGzh",params)
      .then((res) => {
           if (this.refreshing) {
              this.dataList = [];
              this.refreshing = false;
          }
        let list = res.result.records;
        this.dataList = this.dataList.concat(list);
         this.loading = false;
        if(res.result.pages <= this.pageNo){
           this.finished = true;
        }
      })
    },
      onLoad() {
        this.pageNo++
        this.getData();
   
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNo = 0;
      this.refreshing  = true;
      this.onLoad();
    },

  },
}
</script>

<style lang="less" scoped>
// @import '../../assets/less/whon-theme.less';
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

	.u-menu-wrap {
		flex: 1;
	}


.u-search {
  padding: 6px 12px;
  display: flex;
  align-items: center;
  background-color: #eeeeef;
}

.u-btn {
  background-color: #3e78f7;
  color: #fff;
  font-size: 14px;
  padding: 2px 12px;
  line-height: 26px;
  margin-left: 12px;
  border-radius: 4px;
   flex-shrink: 0;
}

.input {
  flex: 1;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ededed;
  padding-left: 8px;
  font-size: 14px;
}

::v-deep .van-pull-refresh {
   min-height:100%
}
</style>
